import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { ReplyMessageDataInterface } from '../../../../interfaces/MessageInterface';
import { MessageDetailsInterface } from '../../../../interfaces/chatMessageInterface';
import { rootStore, RootStore } from '../../../../mobx/rootStore';

interface UseMessageEditingParams {
  setReplyMessage: (value: ReplyMessageDataInterface) => void;
  setSelectedMessage: (value: string | null) => void;
  store?: RootStore;
}

interface UseMessageEditingReturn { 
  editingMessage: MessageDetailsInterface | null;
  isOpenEditMessageModal: boolean;
  setEditingMessage: Dispatch<SetStateAction<MessageDetailsInterface | null>>;
  setIsOpenEditMessageModal: Dispatch<SetStateAction<boolean>>;
  Cancel: () => void;
  editMessageData: (messageData: MessageDetailsInterface) => Promise<void>;
}

export const useMessageEditing = ({
  setReplyMessage,
  setSelectedMessage,
  store = rootStore
}: UseMessageEditingParams): UseMessageEditingReturn => {
  const [editingMessage, setEditingMessage] = useState<MessageDetailsInterface | null>(null);
  const [isOpenEditMessageModal, setIsOpenEditMessageModal] = useState(false);

  const Cancel = useCallback(() => {
    setIsOpenEditMessageModal(false);
    setReplyMessage({});
    if (editingMessage) {
      store.richTextStore.reset();
      setEditingMessage(null);
    }
  }, [editingMessage, setReplyMessage, store]);

  const editMessageData = useCallback(
    async (messageData: MessageDetailsInterface) => {
      setSelectedMessage(null);
      setEditingMessage(messageData);
      store.richTextStore.setUploadedFiles(messageData?.uploadedFile || []);

      if (messageData?.reply && messageData.reply.id) {
        const replyData: ReplyMessageDataInterface = {
          id: messageData.reply.id,
          Message: messageData.reply.message,
          CreatedTime: messageData.reply.createdOn,
          Sender: messageData.reply.sender,
          Sender_id: messageData.reply.sender,
          Files: messageData.reply.files
        };
        setReplyMessage(replyData);
      } else {
        setReplyMessage({});
      }

      store.richTextStore.setContent(`${messageData?.message || ''}<p></p>`);
      setIsOpenEditMessageModal(true);
    },
    [setReplyMessage, setSelectedMessage, store]
  );

  return {
    editingMessage,
    isOpenEditMessageModal,
    setEditingMessage,
    setIsOpenEditMessageModal,
    Cancel,
    editMessageData
  };
};

export default useMessageEditing;
